module.exports = __webpack_public_path__ + "static/media/me.79342c65.JPG";